export default __webpack_public_path__ + "static/media/image-1.cdb0f898.webp";